import types, { ActionCreators } from './types';

const requestMetaDataOK: ActionCreators['RequestMetaDataOK'] = (metaData) => ({
  type: types.REQUEST_META_DATA_OK,
  ...metaData,
});

const resetInitialMetaDataState: ActionCreators['ResetInitialMetaDataState'] = (metaData) => ({
  type: types.RESET_INITIAL_META_DATA_STATE,
  metaData,
});

const actions = {
  requestMetaDataOK,
  resetInitialMetaDataState,
};
export default actions;
